module.exports = __webpack_public_path__ + "src/img/noMore.6395d38b.png";